import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TravelLinkService = {
  getHome: async () => {
    const response = await apiService.get("/home");
    return response.data;
  },
  getMenu: async () => {
    const response = await apiService.get("/menu/top-menu");
    return response.data;
  },
  getAllTestimonial: async () => {
    const response = await apiService.get("/testimonials");
    return response.data;
  },
  getAboutUs: async (slug) => {
    const response = await apiService.get(`/pages/${slug}`);
    return response.data;
  },

  getPageBySlug: async (slug) => {
    const response = await apiService.get(`/pages/${slug}`);
    return response.data;
  },

  getBlog: async () => {
    const response = await apiService.get("/blog/posts");
    return response.data;
  },

  getTeam: async () => {
    const response = await apiService.get("/teams");
    return response.data;
  },
  getAffiliate: async () => {
    const response = await apiService.get("/affiliates");
    return response.data;
  },
  getPaymentMethod: async () => {
    const response = await apiService.get("/payment-methods");
    return response.data;
  },

  getContactReference: async () => {
    const response = await apiService.get("/contact-refrences");
    return response.data;
  },

  getGeneralSetting: async () => {
    const response = await apiService.get("/general-settings");
    return response.data;
  },
  getBanner: async () => {
    const response = await apiService.get("/banners");
    return response.data;
  },

  getSearch: async (packageName) => {
    console.log("🚀 ~ getSearch: ~ packageName:", packageName);
    const response = await apiService.get("/search", {
      params: { q: packageName },
    });

    return response.data;
  },

  // ==============++++======  Services ==============================

  getAllServices: async () => {
    const response = await apiService.get("/services");
    return response.data;
  },

  getService: async () => {
    const response = await apiService.get(`/services/${slug}/packages`);
    return response.data;
  },

  // ==============++++======  Destination Menu ==============================
  getAllCountries: async () => {
    const response = await apiService.get("/destinations");
    return response.data;
  },
  getCountry: async (slug) => {
    const response = await apiService.get(`/destinations/${slug}`);
    return response.data;
  },

  //================== Activity =================================================
  getActivityByCountry: async (slug) => {
    const response = await apiService.get(`/destinations/${slug}/activities`);
    return response.data;
  },
  getPackageByActivity: async (slug) => {
    const response = await apiService.get(`/activities/${slug}/packages`);

    return response.data;
  },
  getAllActivites: async () => {
    const response = await apiService.get("/activities");
    return response.data;
  },
  getActivity: async (slug) => {
    const response = await apiService.get(`/activities/${slug}`);
    return response.data;
  },

  // =====================    Packages =========================================
  getAllPackages: async () => {
    const response = await apiService.get("/packages");
    return response.data;
  },
  getPackageByCountry: async (slug) => {
    const response = await apiService.get(`/destinations/${slug}/packages`);

    return response.data;
  },
  getPackage: async (slug) => {
    const response = await apiService.get(`/packages/${slug}`);
    return response.data;
  },

  //   getById: async (id) => {
  //     const response = await apiService.get(`/appointments/${id}`);
  //     // console.log("getbyid",response);
  //     return response.data;
  //   },

  // testimonial
  saveTestimonial: async (data) => {
    console.log("🚀 ~ saveTestimonial: ~ data:", data);

    try {
      const response = await apiService.post("/testimonials", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },

  saveMessage: async (data) => {
    const response = await apiService.post("/contact-messages", data);
    return response.data;
  },
  saveBooking: async (data) => {
    const response = await apiService.post("/bookings", data);
    return response.data;
  },

  customizeModal: async (data) => {
    const response = await apiService.post("/customize-trips", data);
    return response.data;
  },
  verifyCaptcha: async (data) => {
    const response = await apiService.post("/verify-captcha", data);
    return response.data;
  },
};

export default TravelLinkService;
